import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dfd23eda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contracts-settings" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-sm font-medium px-2" }
const _hoisted_4 = { class: "flex flex-col gap-4 mt-4 overflow-hidden overflow-y-auto max-h-80 p-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm font-medium text-gray-500 text-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_7 = { class: "px-2 mt-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_9 = { class: "flex items-center justify-between" }
const _hoisted_10 = { class: "mt-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal = _resolveComponent("modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.isUpdateModalShowed)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "medium",
          title: "Редактирование записи",
          loading: _ctx.state.isUpdateModalLoading,
          "confirm-disabled": _ctx.isModalInvalid,
          onConfirm: _ctx.updateItem,
          onCancel: _ctx.onCancelUpdateItem
        }, {
          default: _withCtx(() => [
            (_ctx.state.updateModalItem)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("p", _hoisted_3, "Ключ: " + _toDisplayString(_ctx.state.updateModalItem.key), 1),
                  _createElementVNode("div", _hoisted_4, [
                    (_ctx.state.updateModalItemValues.length === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Список значений пуст"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.updateModalItemValues, (val, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "container__value flex items-start gap-2",
                        key: `value-${i}`
                      }, [
                        _createVNode(_component_the_input, {
                          placeholder: "Введите значение",
                          value: val,
                          disabled: _ctx.state.isUpdateModalLoading,
                          "is-invalid": Boolean(_ctx.state.updateModalItemValidations[i]),
                          "validation-error-str": _ctx.state.updateModalItemValidations[i],
                          "onUpdate:value": (value) => _ctx.onUpdateModalItemValue(value, i)
                        }, null, 8, ["value", "disabled", "is-invalid", "validation-error-str", "onUpdate:value"]),
                        _createVNode(_component_the_button, {
                          class: "red small mt-3",
                          disabled: _ctx.state.isUpdateModalLoading,
                          onClick: ($event: any) => (_ctx.onDeleteModalItem(i))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_the_button, {
                      class: "primary small w-full",
                      disabled: _ctx.state.isUpdateModalLoading,
                      onClick: _ctx.onAddModalItem
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading", "confirm-disabled", "onConfirm", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_page_title, { title: "Список конфигов" })
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.state.isFailed)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.isLoading,
            text: "При получении списка конфигов произошла ошибка",
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadConfig(_ctx.state.page)))
          }, null, 8, ["loading"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.isLoading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                "with-limit": "",
                loading: _ctx.state.isLoading,
                columns: _ctx.COLUMNS,
                rows: _ctx.state.items,
                "pagination-limit": _ctx.state.limit,
                "pagination-total-items": _ctx.state.totalItems,
                "pagination-current-page": _ctx.state.page,
                "pagination-total-pages": _ctx.state.totalPages,
                onChangePage: _ctx.loadConfig,
                onChangeLimit: _ctx.onLimitChange
              }, {
                td: _withCtx(({ row, column }) => [
                  (column.key === 'key')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (row.key === 'dogovor24_allowed_signer_emails')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("Разрешённые подписанты Д24")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(row.key), 1)
                            ], 64))
                      ], 64))
                    : (column.key === 'value')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(row.value.join(', ')), 1)
                        ], 64))
                      : (column.key === 'actions')
                        ? (_openBlock(), _createBlock(_component_the_button, {
                            key: 2,
                            class: "primary small",
                            disabled: !_ctx.isCanUpdate,
                            onClick: ($event: any) => (_ctx.onStartUpdateItem(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createTextVNode(_toDisplayString(row[column.key]), 1)
                          ], 64))
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}